import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles/global.css';

const root = document.getElementById('root');
if (!root) throw new Error('#root not found');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>
);
// pcp-react-ready (скрытие SEO-shell) выставляет Company ПОСЛЕ meaningful render
// (вердикт/карточка готовы), НЕ сразу при mount — иначе shell прячется до данных
// и при сбое API бот/человек увидят skeleton вместо SEO-контента (cx-review HIGH).
